import style from '../index.module.css'

import React from 'react'

import type { FilterOperator } from 'types/filter-page'
import type { NativeTag } from 'types/track'

import { Checkbox, Flex, Text } from 'components/ds'
import HighlightedText from 'components/ui/highlighted-text'

type SelectedTagsProps = {
  selectedTags: NativeTag[]
  onRemoveTag: (_tagIds: number[], _operator: FilterOperator) => void
  searchValue?: string
}

const SelectedTags = ({
  selectedTags,
  onRemoveTag,
  searchValue,
}: SelectedTagsProps) => {
  if (!selectedTags?.length) return null
  return (
    <Flex direction="column" width="100%">
      {selectedTags.map(tag => (
        <Flex
          key={tag.id}
          direction="row"
          gap="2"
          className={style.Checkbox_RowContainer}
          asChild
        >
          <Text size="2" as="label">
            <Checkbox
              checked={true}
              onCheckedChange={() => {
                const newTagIds = selectedTags
                  .filter(v => v.id !== tag.id)
                  .map(v => v.id)
                onRemoveTag(newTagIds.length ? newTagIds : undefined, 'equals')
              }}
            />
            <HighlightedText
              text={tag.name}
              highlights={searchValue ? [searchValue] : []}
              customColors={{
                background: 'var(--disco-yellow)',
              }}
            />
          </Text>
        </Flex>
      ))}
    </Flex>
  )
}

export default SelectedTags
